<div class="transaction-list-item-container"
     (click)="selectItem.emit(transaction)"
     *ngIf="transaction">
  <div class="transaction-list-item-container__info-item">

    <ng-container>
      <img class="transaction-list-icon" [ngClass]="categoryIcon" />
    </ng-container>

    <div class="info-data">
      <div class="info-title">{{transaction?.description || ''}}</div>
      <div class="info-sub-title">{{ getCategoryName(transaction?.typeGroup) || ''}}</div>
    </div>
  </div>

  <div class="transaction-list-item-container__item-value"
       [ngClass]="balanceValidation(transaction?.additions?.balanceAfterTransaction)
       ? 'container-multi-column'
       : 'container-mono-column'">
    <div *ngIf="!(showBalanceData && balanceValidation(transaction?.additions?.balanceAfterTransaction))"></div>
    <div class="transaction-balance-amount"
         [ngClass]="validationClassName">
      {{getTransactionAmount(transaction?.transactionAmountCurrency, transaction?.creditDebitIndicator, accountType)}}
    </div>
    <div class="transaction-balance-amount"
         *ngIf="showBalanceData && balanceValidation(transaction?.additions?.balanceAfterTransaction)">
      {{getBalanceData(transaction?.transactionAmountCurrency?.currencyCode, transaction?.additions?.balanceAfterTransaction)}}
    </div>
  </div>
</div>
